import { L10n } from '../../ts/L10n/L10n';
import { ISubscriptionInfo, SubscriptionTargetTypes } from '../../ts/models/ISubscriptionInfo';
import { Subscriptions } from '../../dda/resources/Subscriptions';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { Messages } from '../../codegen/Localize';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { ActionDialogBodyWithTextInput, ActionDialogBodyWithTextInputProps, ActionDialogBodyWithTextInputState } from '../../commonInfra/dialogs/ActionDialogBodyWithTextInput';
import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';


export const SUCCESS_TOAST_TEST_ID = 'change-subscription-subject-success';

type ChangeSubscriptionSubjectActionDialogProps = ActionDialogBodyWithTextInputProps & {
  id: string;
  subject: string;
}

export function getTextInputLabel(targetType: string, targetName: string): string {
  let label = ''; // This should only be used if the server returns bad data.
  switch (targetType) {
    case SubscriptionTargetTypes.view:
      label = Messages.confirmChangeViewSubscriptionSubject({ VIEW_NAME: L10n.elideIfLong(targetName) });
      break;
    case SubscriptionTargetTypes.workbook:
      label = Messages.confirmChangeWorkbookSubscriptionSubject({ WORKBOOK_NAME: L10n.elideIfLong(targetName) });
      break;
  }

  return label;
}

function changeSubject(subscription: ISubscriptionInfo): Promise<IResult> {
  const dialogInstance = openReactActionDialog<ChangeSubscriptionSubjectActionDialogProps, ActionDialogBodyWithTextInputState, unknown>({
    title: Messages.changeSubject(),
    bodyComponent: ActionDialogBodyWithTextInput,
    initialDialogState: {
      text: subscription.subject,
      errorMessage: undefined,
    },
    initialBodyProps: {
      id: subscription.id,
      subject: subscription.subject,
      label: getTextInputLabel(subscription.targetType, subscription.targetName),
      maxLength: 255,
    },
    actionName: Messages.changeSubject(),
    actionDisabled: (props, state) => state.text.length === 0 || state.text.length > props.maxLength,
    action: changeSubjectAction,
    dialogWidth: TabDialogWidth.width375px,
    dismissDialogOnActionFailed: false,
  });

  return Promise.resolve(dialogInstance.result);
}

export async function changeSubjectAction(
  props: ChangeSubscriptionSubjectActionDialogProps,
  dialogState: ActionDialogBodyWithTextInputState,
  updateDialogState: React.Dispatch<MergeOrUpdateStateAction<ActionDialogBodyWithTextInputState>>): Promise<IResult> {

  const result = await Subscriptions.changeSubject(props.id, dialogState.text);

  return notify(result, props.subject, dialogState.text, updateDialogState);
}

export function notify(result: IResult, originalSubject: string, newSubject: string,
  updateDialogState: React.Dispatch<MergeOrUpdateStateAction<ActionDialogBodyWithTextInputState>>): Promise<IResult> {

  if (result.errors && result.errors.length) {
    updateDialogState({ errorMessage: Messages.changeSubjectFailure({ SUBJECT: originalSubject }) });
    return Promise.reject();
  } else {
    ToasterService.instance.pop({
      type: ToastType.Info,
      text: Messages.changeSubjectSuccess({ SUBJECT: newSubject }),
      testId: SUCCESS_TOAST_TEST_ID
    });
  }
  return Promise.resolve(result);
}

export const ChangeSubscriptionSubjectAction = {
  changeSubject
};
